import React, {useContext, useEffect} from 'react';

import {useFormikContext} from "formik";

import Grid from "@mui/material/Grid";

import ContractNumberField from "./ContractNumberField";
import WsPasswordField from "./WsPasswordField";

import {ShippingMethodFormContext} from "../../../context/ShippingMethodFormContext";
import {ShippingMethodsDiscr} from "../../../../../../../utils/ShippingMethods";
import FormikInput from "../../../../../../../components/input/new/FormikInput";

function ApiFields(props) {
    const {isApi, discr} = useContext(ShippingMethodFormContext);

    const {validateField} = useFormikContext()

    // trigger validation of api fields, also when the method type changes:
    // contractNumber is not required for DPD
    useEffect(() => {
        validateField('contractNumber');
        validateField('wsPassword');
    }, [isApi, discr]);

    if (!isApi) {
        return null;
    }

    return (
        <Grid item container rowSpacing={2}>
            <Grid item container columnSpacing={2}>
                <Grid item xs={6}>
                    <ContractNumberField />
                </Grid>
                <Grid item xs={6}>
                    <WsPasswordField />
                </Grid>
            </Grid>
            {ShippingMethodsDiscr.DPD === discr && (
                <Grid item container columnSpacing={2} rowSpacing={2}>
                    <Grid item xs={6}>
                        <FormikInput
                        name={'userId'}
                        label={'shippingMethods.form.field.dpdUserId.label'}
                        placeholder={'shippingMethods.form.field.dpdUserId.placeholder'}
                        required={true}
                    /></Grid>
                    <Grid item xs={6}>
                        <FormikInput
                            name={'customerNumber'}
                            label={'shippingMethods.form.field.dpdCustomerNumber.label'}
                            placeholder={'shippingMethods.form.field.dpdCustomerNumber.placeholder'}
                            required={true}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormikInput
                            name={'customerCenterNumber'}
                            label={'shippingMethods.form.field.dpdCustomerCenterNumber.label'}
                            placeholder={'shippingMethods.form.field.dpdCustomerCenterNumber.placeholder'}
                            required={true}
                        />
                    </Grid>
                    {/* DPD Secure: delivery against signature, requires the recipient's mobile at checkout */}
                    <Grid item xs={12}>
                        <FormikInput
                            type={'checkbox'}
                            name={'secureService'}
                            label={'shippingMethods.form.field.dpdSecureService.label'}
                            noPadding={true}
                        />
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
}

export default ApiFields;
